import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Refresh from '@mui/icons-material/Refresh'
import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { type SolarProjectUpdateDto } from '../../../../api-schema-types/solar/SolarProjectDomainDtos'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useGetSolarProjectQuery } from '../../../../api-services/solar/solarApi'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { ProjectStatusChip } from '../../../components/chips/ProjectStatusChip'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'
import EditSolarPlantForm from './EditSolarPlantForm'

import { selectCurrentSolarProjectId, resetEditSolarPlant, setCurrentSolarProjectId } from './editSolarPlantSlice'

const EditSolarPlantPage: React.FC = () => {
  const params = useParams<any>()
  const history = useHistory()
  const dispatch = useAppDispatch()

  const currentSolarProjectId = useAppSelector<number | null>(selectCurrentSolarProjectId)
  let solarProjectId: number | null = null
  let solarProject: SolarProjectUpdateDto | null = null

  if (Boolean(params.solarProjectId) && solarProjectId !== '') {
    solarProjectId = params.solarProjectId
  }

  // ================================================================================================================
  // GET Query

  const skipQuery = solarProjectId === null
  const getProjectApiResult = useGetSolarProjectQuery({ solarProjectId }, { skip: skipQuery })

  const refetchProject = getProjectApiResult.refetch

  if (getProjectApiResult.error !== null && !getProjectApiResult.isLoading && (getProjectApiResult.data != null)) {
    solarProject = getProjectApiResult.data
  }

  useEffect(() => {
    if (currentSolarProjectId !== solarProjectId) {
      dispatch(resetEditSolarPlant())
      dispatch(setCurrentSolarProjectId(solarProjectId))
    }
  }, [getProjectApiResult.isSuccess])

  // ================================================================================================================

  // ================================================================================================================
  // Handlers

  const handleRefetch = async (): Promise<void> => {
    await refetchProject()
  }

  const isProjectDataLoaded = (): boolean => {
    if (getProjectApiResult.error != null) return false
    if (getProjectApiResult.isLoading) return false
    if (getProjectApiResult.isFetching) return false
    return true
  }

  // ================================================================================================================

  return (
    <>
      <Grid container>
        <Grid item lg={12}>
          <Grid container sx={{ mb: 4 }}>
            <Grid item lg={8}>
              <Typography variant={'h5'}>
                {' '}
                {solarProject?.identifier?.projectId} - {(solarProject !== null) ? `${solarProject?.identifier?.projectName} ` : ''} [{solarProject?.identifier?.solarProjectId}]
                {(solarProject !== null)
                  ? (
                    <>
                      &nbsp;
                      &nbsp;
                      <ProjectStatusChip projectStatus={solarProject.summary.projectStatus}/>
                    </>
                    )
                  : ''
                }
              </Typography>
            </Grid>
            <Grid item lg={4} sx={{ textAlign: 'right' }}>
              <Button variant={'outlined'} onClick={() => history.push('/app/solar-engineering/solar-plants')} startIcon={<ArrowBackIcon/>}>
                Projects
              </Button>
            </Grid>
          </Grid>

          <Paper>
            <Box sx={{ p: 4, mt: 3 }}>
              {getProjectApiResult.isLoading && <LoadingComponent/>}
              {(getProjectApiResult.error != null) &&
                <ErrorComponent message={RtkQueryHelper.mapResponseError(getProjectApiResult.error)}/>}

              <Grid container justifyContent="right" sx={{ mb: 2 }}>
                <Grid item>
                  <Grid container spacing={2}>
                    <Grid item>
                      <Button variant={'contained'} type="button" onClick={handleRefetch}>
                        <Refresh/>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>

              { isProjectDataLoaded() && getProjectApiResult.data !== null && getProjectApiResult.data !== undefined && (
                <EditSolarPlantForm solarProject={getProjectApiResult.data} triggerRefetch={refetchProject}/>
              )}

            </Box>

            {/* ==================================================================================================== */}

          </Paper>

        </Grid>
      </Grid>
    </>
  )
}

export default EditSolarPlantPage
